module.exports = __webpack_public_path__ + "img/hang1.c663aa70.png";